import { render, staticRenderFns } from "./PtoBalance.vue?vue&type=template&id=671e65f4&scoped=true"
import script from "./PtoBalance.vue?vue&type=script&lang=js"
export * from "./PtoBalance.vue?vue&type=script&lang=js"
import style0 from "./PtoBalance.vue?vue&type=style&index=0&id=671e65f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671e65f4",
  null
  
)

export default component.exports